<template>
  <div id="minus-point" class="example-preview table-responsive overflow-auto mt-3">
    <table class="table text-left table-hover table-bordered table-vertical-center b-table">
      <thead>
      <tr style="background-color: #472F92; color: white">
        <th style="width: 100px;">STT</th>
        <th>Mô tả</th>
        <th>Phòng ban</th>
        <th>Quý</th>
        <th>Nhân sự</th>
        <th style="width: 90px">Điểm trừ</th>
        <th class="text-center" style="width: 100px">Hành động</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="dataMinusPoint?.length > 0">
        <tr v-for="(item, index) in dataMinusPoint" :key="item.id">
          <td>{{ getIndex(page, index, 20) }}</td>
          <td>
            <el-input
                type="textarea" autosize
                v-model="item.reason" placeholder="Nhập mô tả điểm trừ"
                @change="handleChangeMinusPoint(item)"
            />
          </td>
          <td>{{ item?.department ?? '' }}</td>
          <td>
            <span style="white-space: nowrap">{{ item?.quarter }}</span>
          </td>
          <td>{{ item?.human }}</td>
          <td>
            <span>{{ item.minusPoint }}</span>
          </td>
          <td class="text-center">
            <button class="btn btn-outline-danger p-0 mr-2"
                    title="Xoá" type="button"
                    @click="confirmDelete(item)"><i
                class="el-icon-delete p-2"></i></button>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="11" class="text-center">Chưa có dữ liệu</td>
        </tr>
      </template>
      </tbody>
    </table>
    <el-dialog
        class="responsive" v-if="isDelete" width="30%"
        :visible.sync="isDelete" :show-close="false"
        append-to-body title="Xoá điểm trừ"
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray"/>
      <span style="word-break: break-word">Bạn có chắc chắn muốn xoá điểm trừ <span style="font-weight: 700">{{recordSelected.reason}}</span> không?</span>
      <div class="d-flex align-items-center justify-content-end mt-4">
        <el-button type="info" @click="isDelete = false">Đóng</el-button>
        <el-button type="primary" @click="handleDelete" :loading="loading" :disabled="loading">Xác nhận</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { statusOptions } from "@/view/pages/manage-team-lead-index/model/TeamLeadIndex";
import { DELETE_MINUS_POINT, UPDATE_MINUS_POINT } from "@/core/services/store/okrs/okr.module";

export default {
  name: 'TableManageMinusPoint',
  data() {
    return {
      loading: false,
      isDelete: false,
      statusOptions,
      recordSelected: null,
    }
  },
  props: {
    dataMinusPoint: {
      type: Array,
      required: true,
      default: () => []
    },
    page: {
      type: Number,
      required: true,
      default: 1
    }
  },
  methods: {
    confirmDelete(record) {
      this.isDelete = true
      this.recordSelected = record;
    },
    handleDelete() {
      this.loading = true
      this.$store.dispatch(DELETE_MINUS_POINT, this.recordSelected.id).then(res => {
        if (!res.error) {
          this.isDelete = false
          this.$message.success('Xoá điểm trừ thành công !')
          this.$emit('getListMinusPoint')
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })
    },
    handleChangeMinusPoint(item) {
      const payload = {
        id: item?.id,
        description: item?.reason,
        point: item?.minusPoint,
      }
      this.$store.dispatch(UPDATE_MINUS_POINT, payload).then(res => {
        if (!res.error) {
          this.$message.success('Cập nhật điểm trừ thành công !')
          this.$emit('getListMinusPoint')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getIndex(page, index, limit) {
      return this.getIndexPaginate(page, index, limit)
    },
  }
}
</script>
<style>
#minus-point .el-textarea__inner {
  min-height: 32px !important;
}
</style>